import React from 'react';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let Binocular = props => {
  const { template, previousExams, overviewName, examId,fieldsValues } = props;
  const renderContent = (fieldsValues) => (
    <>
      <DisplayField
        isVisible={template.fields.cover_test.fields.distance.visible}
        label={`${template.fields.cover_test.custom_label + ' (' + template.fields.cover_test.fields.distance.custom_label + ')'}:`}
        value={fieldsValues?.cover_test?.distance}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.cover_test.fields.near.visible}
        label={`${template.fields.cover_test.custom_label + ' (' + template.fields.cover_test.fields.near.custom_label + ')'}:`}
        value={fieldsValues?.cover_test?.near}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.cover_test.fields.nra.visible}
        label={`${template.fields.cover_test.fields.nra.custom_label}:`}
        value={fieldsValues?.cover_test?.nra}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.cover_test.fields.pra.visible}
        label={`${template.fields.cover_test.fields.pra.custom_label}:`}
        value={fieldsValues?.cover_test?.pra}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.cover_test.fields.npc.visible}
        label={`${template.fields.cover_test.fields.npc.custom_label}:`}
        value={fieldsValues?.cover_test?.npc}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.cover_test.fields.fcc.visible}
        label={`${template.fields.cover_test.fields.fcc.custom_label}:`}
        value={fieldsValues?.cover_test?.fcc}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.cover_test.fields.accomodation_facility.visible}
        label={`${template.fields.cover_test.fields.accomodation_facility.custom_label}:`}
        value={fieldsValues?.cover_test?.accomodation_facility}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.cover_test.fields.dem.visible}
        label={`${template.fields.cover_test.fields.dem.custom_label}:`}
        value={fieldsValues?.cover_test?.dem}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.cover_test.fields.amplitude_of_accomodation.visible}
        label={`${template.fields.cover_test.fields.amplitude_of_accomodation.custom_label}:`}
        value={fieldsValues?.cover_test?.amplitude_of_accomodation}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.phorias.fields.horizontal_distance.visible}
        label={`${template.fields.phorias.custom_label + ' (' + template.fields.phorias.fields.horizontal_distance.custom_label + ')'}:`}
        value={fieldsValues?.phorias?.horizontal_distance}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.phorias.fields.vergences_distance.visible}
        label={`${template.fields.phorias.custom_label + ' (' + template.fields.phorias.fields.vergences_distance.custom_label + ')'}:`}
        value={fieldsValues?.phorias?.vergences_distance}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.phorias.fields.vertical_distance.visible}
        label={`${template.fields.phorias.custom_label + ' (' + template.fields.phorias.fields.vertical_distance.custom_label + ')'}:`}
        value={fieldsValues?.phorias?.vertical_distance}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.phorias.fields.horizontal_near.visible}
        label={`${template.fields.phorias.custom_label + ' (' + template.fields.phorias.fields.horizontal_near.custom_label + ')'}:`}
        value={fieldsValues?.phorias?.horizontal_near}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.phorias.fields.vergences_near.visible}
        label={`${template.fields.phorias.custom_label + ' (' + template.fields.phorias.fields.vergences_near.custom_label + ')'}:`}
        value={fieldsValues?.phorias?.vergences_near}
        className="col-2 py-4"
      />
      <DisplayField
        isVisible={template.fields.phorias.fields.vertical_near.visible}
        label={`${template.fields.phorias.custom_label + ' (' + template.fields.phorias.fields.vertical_near.custom_label + ')'}:`}
        value={fieldsValues?.phorias?.vertical_near}
        className="col-2 py-4"
      />
      {fieldsValues?.note && <DisplayField
        isVisible={template.fields.notes.visible}
        label={`${template.fields.notes.custom_label}:`}
        value={fieldsValues.note}
        className="col-2 py-4"
      />}
    </>
  )

  return (
    <>
      {fieldsValues && <div className="row mx-0">{renderContent(fieldsValues)}</div>}
      {previousExams?.filter(item => item.id !== examId).map(prevExam =>
        <div className="col-12 border rounded mb-4 px-0">
          <div className="row mx-0">
            <OldValuesHeader prevExam={prevExam} overviewName={overviewName} examId={examId} />
            {renderContent(prevExam?.binocular)}
          </div>
        </div>
      )}
    </>
  )
}


export default Binocular;